export default __webpack_public_path__ + "static/media/laundry2-after-1440w.7d9b7362.webp";